export default {
  label: {
    title: 'Configuraciones',
    tabs: {
      style: 'Estilo',
      sharing: 'Compartir',
      users: 'Usuarios con acceso',
      contract: 'Agregar Contrato',
    },
  },
};
